import React from 'react';
import cn from 'classnames';

function FlexBox({ children }) {
  return (
    <section className="flex-box">
      {React.Children.map(children, c => {
        return (
          <Column small={c.props.small} medium={c.props.medium} large={c.props.large} flex={c.props.flex ? true: false} extraClassName={c.props.extraClassName}>
            {c}
          </Column>
        );
      })}
    </section>
  );
};

export function Column({ children, small, medium, large, flex, extraClassName }) {
  return (
    <div className={cn('column', extraClassName, {
      [`small-${small}`]: small,
      [`medium-${medium}`]: medium,
      [`large-${large}`]: large,
      flex: flex,
    })}>
      {children}
    </div>
  );
}

export default FlexBox;
